import React, { useState } from 'react';
import { Section } from './ui/Section';
import { motion, AnimatePresence } from 'framer-motion';
export function FAQ() {
  const faqs = [{
    q: '¿Este método es para mí si tengo más de 60 años?',
    a: 'Absolutamente. El Método Wellaging 360° funciona a cualquier edad después de los 40. La edad biológica (cómo te sentís) es más importante que la cronológica. Si tenés más de 60 y nunca hiciste ejercicio, hay adaptaciones específicas.'
  }, {
    q: '¿Necesito comprar productos caros importados?',
    a: 'No. Uno de los pilares del método es que TODO esté adaptado a la realidad argentina. Productos de farmacia local, alimentos de supermercado y suplementos accesibles.'
  }, {
    q: '¿Cuánto tiempo me toma por día realmente?',
    a: '15 minutos máximo. Rutina de piel (5 min AM/PM) y Ejercicio (10 min). La preparación de comidas se hace en 1 hora el domingo (meal prep). Diseñado para mujeres ocupadas.'
  }, {
    q: '¿Cómo accedo al contenido después de comprar?',
    a: 'Instantáneo. Te llega un email con el link de descarga del Ebook Principal y los Bonuses. Todo descargable en tu celular o computadora.'
  }, {
    q: '¿Es un pago único o hay cargos recurrentes?',
    a: 'Pago ÚNICO de $17.990. No hay suscripciones ocultas ni cargos recurrentes. El contenido es tuyo para siempre.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <Section bg="cream-dark" data-id="element-236">
      <div className="max-w-3xl mx-auto" data-id="element-237">
        <div className="text-center mb-16" data-id="element-238">
          <h2 className="text-4xl font-serif text-charcoal mb-4" data-id="element-239">
            Preguntas Frecuentes
          </h2>
        </div>

        <div className="space-y-4" data-id="element-240">
          {faqs.map((faq, idx) => <div key={idx} className="border-b border-gold/20" data-id="element-241">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full py-6 text-left flex justify-between items-center gap-4 focus:outline-none group" data-id="element-242">
                <span className="font-serif text-xl text-charcoal group-hover:text-olive transition-colors" data-id="element-243">
                  {faq.q}
                </span>
                <span className="text-gold text-2xl font-light" data-id="element-244">
                  {openIndex === idx ? '−' : '+'}
                </span>
              </button>
              <AnimatePresence data-id="element-245">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.3
            }} data-id="element-246">
                    <div className="pb-8 text-charcoal-light font-light leading-relaxed pr-8" data-id="element-247">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </Section>;
}